import { ThemeConfig } from "antd/es/config-provider/context"

export const theme: ThemeConfig = {
    token: {
        // colorPrimary: "#f88a0c",
        borderRadius: 8,
        // fontFamily: "Myanmar3, sans-serif",
        fontFamily: "var(--font-sans)",
        colorText: "var(--color-2C)",
        // borderRadiusLG: 2,
    },
    components: {
        Button: {
            // controlHeight: 40,
            borderRadius: 2,
            borderRadiusLG: 4,
            // colorTextTertiary: "#fff",
            colorError: "var(--color-danger)",
            fontSizeLG: 14,
            fontSize: 14,
            fontFamily: "var(--font-poppins)"
        },
        Table: {
            borderColor: "transparent",
            headerColor: "#fff",
            headerBg: "var(--color-2C)",
            fontWeightStrong: 500,
        },
        Input: {
            borderRadius: 2,
            borderRadiusLG: 4,
            fontFamily: "var(--font-poppins)",
            colorText: "var(--color-2C)",
        },
        Select: {
            borderRadius: 2,
            borderRadiusLG: 4,
            fontFamily: "var(--font-poppins)",
        },
        DatePicker: {
            borderRadius: 4,
            borderRadiusLG: 4,
            borderRadiusOuter: 4,
            fontFamily: "var(--font-poppins)",
        },
        InputNumber: {
            borderRadius: 2,
            borderRadiusLG: 4,
            fontFamily: "var(--font-poppins)",
        },
        Form: {
            fontFamily: "var(--font-poppins)",
            labelColor: "var(--color-2C)",
            colorError: "var(--color-danger)",
        },
        Dropdown: {
            fontFamily: "var(--font-poppins)",
        },
        Notification: {
            fontFamily: "var(--font-poppins)",
        },
        Tag: {
            fontFamily: "var(--font-poppins)",
        }
    },
    cssVar: true,
}